/* eslint-disable react/jsx-key */
import React from 'react';
import PropTypes from 'prop-types';
import { parseISO, parse } from 'date-fns';
import _isEmpty from 'lodash/isEmpty';
import Message from 'components/Message';
import { manageServicesAvailabilityShape } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import { messages } from './AvailabilityDetails.messages';
import './AvailabilityDetails.scss';

const { block, element } = bem('availability-details');

const AvailabilityDetails = ({ recurrence, singleDayExceptions, daysToDisplay }) => {
  if (_isEmpty(recurrence) && _isEmpty(singleDayExceptions)) return null;

  const renderRepeatsOn = () => {
    return (
      <ul className={element('repeats-on')}>
        {daysToDisplay.map(({ en, long }) => (
          <li key={en} className="grid grid--flush">
            <p className="grid__item 1/2">{long}</p>
            <div className="grid__item 1/2">
              {recurrence[en].map(({ startTime, endTime }, idx) => (
                <Message
                  // eslint-disable-next-line react/no-array-index-key
                  key={`recurrence-${idx}`}
                  as="p"
                  message={messages.timeRange}
                  values={{
                    startTime: parse(startTime, 'HH:mm', new Date()),
                    endTime: parse(endTime, 'HH:mm', new Date()),
                  }}
                />
              ))}
            </div>
          </li>
        ))}
      </ul>
    );
  };

  const renderSingleDayException = days => (
    <ul>
      {days &&
        days.map(({ id, date, startTime, endTime, description }) => (
          <li key={id} className="grid grid--flush mb-r">
            <Message className="grid__item 1/2" format="medium-w-dow-no-year" value={parseISO(date)} />
            <Message
              className="grid__item 1/2"
              message={messages.timeRange}
              values={{
                startTime: parse(startTime, 'HH:mm', new Date()),
                endTime: parse(endTime, 'HH:mm', new Date()),
              }}
            />
            {description && <span className={element('description', 'grid__item 1/1')}>{description}</span>}
          </li>
        ))}
    </ul>
  );

  const availableSingleDayExceptions =
    singleDayExceptions && singleDayExceptions.filter(({ availability }) => availability === 'available');
  const unavailableSingleDayExceptions =
    singleDayExceptions && singleDayExceptions.filter(({ availability }) => availability === 'unavailable');

  return (
    <div className={block('grid')}>
      <Message as="h6" className={element('header', 'grid__item')} message={messages.availability} />
      {!_isEmpty(recurrence) && (
        <div className="grid__item mb-l">
          <Message className={element('label')} message={messages.repeatsOn} />
          {renderRepeatsOn()}
        </div>
      )}
      {!_isEmpty(availableSingleDayExceptions) && (
        <div className="grid__item">
          <Message className={element('label')} message={messages.availableSingleDayExceptions} />
          {renderSingleDayException(availableSingleDayExceptions)}
        </div>
      )}
      {!_isEmpty(unavailableSingleDayExceptions) && (
        <div className="grid__item">
          <Message className={element('label')} message={messages.unavailableSingleDayExceptions} />
          {renderSingleDayException(unavailableSingleDayExceptions)}
        </div>
      )}
    </div>
  );
};

AvailabilityDetails.propTypes = {
  recurrence: manageServicesAvailabilityShape.recurrence,
  singleDayExceptions: manageServicesAvailabilityShape.singleDayExceptions,
  daysToDisplay: PropTypes.arrayOf(
    PropTypes.shape({
      en: PropTypes.string,
      long: PropTypes.string,
    })
  ),
};

export default AvailabilityDetails;
